import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import { isNotUndefinedOrNull } from "../../FunctionsCore";
const HeadingStyle = styled(Typography)(({ theme }) => ({
    "color": theme.palette["primary"].darker,
    "fontWeight": 350
}));
const HeadingsSectionStyle = styled("div")(() => ({
    "display": "flex",
    "flexDirection": "column",
    "gap": "24px",
    "marginBottom": "50px",
    "textAlign": "center",
}));
export const HeadingSection = (props) => {
    const { sectionHeading, sectionSubHeading } = props;
    return (_jsx(_Fragment, { children: isNotUndefinedOrNull(sectionHeading) || isNotUndefinedOrNull(sectionSubHeading) ? (_jsxs(HeadingsSectionStyle, { children: [_jsx(HeadingStyle, Object.assign({ variant: "h2" }, { children: sectionHeading })), _jsx(Typography, Object.assign({ variant: "h6" }, { children: sectionSubHeading }))] })) : (_jsx(_Fragment, {})) }));
};
